//NOTE autogenerated by export script
export {AllDevicesService as AllDevices} from './allDevices.service'
export {AnimalSpeciesService as AnimalSpecies} from './animalSpecies.service'
export {AnimalSpeciesCustomersService as AnimalSpeciesCustomers} from './animalSpeciesCustomers.service'
export {BatteriesService as Batteries} from './batteries.service'
export {BatteryTypesService as BatteryTypes} from './batteryTypes.service'
export {BootloaderVersionsService as BootloaderVersions} from './bootloaderVersions.service'
export {CamerasService as Cameras} from './cameras.service'
export {CheckIridiumDeviceStatusService as CheckIridiumDeviceStatus} from './checkIridiumDeviceStatus.service'
export {CollarsService as Collars} from './collars.service'
export {CommandsAdminService as CommandsAdmin} from './commandsAdmin.service'
export {CommandsCustomerService as CommandsCustomer} from './commandsCustomer.service'
export {ConfigFilesService as ConfigFiles} from './configFiles.service'
export {ConfigurationDevicesService as ConfigurationDevices} from './configurationDevices.service'
export {DataLoggersService as DataLoggers} from './dataLoggers.service'
export {DeviceClassesService as DeviceClasses} from './deviceClasses.service'
export {DeviceCommandTypesService as DeviceCommandTypes} from './deviceCommandTypes.service'
export {DeviceFeaturesService as DeviceFeatures} from './deviceFeatures.service'
export {DeviceTypesAdminService as DeviceTypesAdmin} from './deviceTypesAdmin.service'
export {DeviceTypesCustomerService as DeviceTypesCustomer} from './deviceTypesCustomer.service'
export {DropOffsService as DropOffs} from './dropOffs.service'
export {ExternalSensorsService as ExternalSensors} from './externalSensors.service'
export {FirmwareClassesService as FirmwareClasses} from './firmwareClasses.service'
export {FirmwareVersionsService as FirmwareVersions} from './firmwareVersions.service'
export {HousingTypesService as HousingTypes} from './housingTypes.service'
export {InitialDeviceRelationControllerService as InitialDeviceRelation} from './initialDeviceRelationController.service'
export {LongRangeDevicesService as LongRangeDevices} from './longRangeDevices.service'
export {PCBTypesService as PCBTypes} from './pCBTypes.service'
export {ParameterListVersionService as ParameterListVersion} from './parameterListVersion.service'
export {ParametersAdminService as ParametersAdmin} from './parametersAdmin.service'
export {ParametersCategoriesService as ParametersCategories} from './parametersCategories.service'
export {ParametersCustomerService as ParametersCustomer} from './parametersCustomer.service'
export {RefurbSplitControllerService as RefurbSplit} from './refurbSplitController.service'
export {ScheduleTemplatesAdminService as ScheduleTemplatesAdmin} from './scheduleTemplatesAdmin.service'
export {ScheduleTemplatesCustomerService as ScheduleTemplatesCustomer} from './scheduleTemplatesCustomer.service'
export {ScheduleTypesService as ScheduleTypes} from './scheduleTypes.service'
export {SchedulesService as Schedules} from './schedules.service'
export {SubsystemsService as Subsystems} from './subsystems.service'
export {TT4SensorsService as TT4Sensors} from './tT4Sensors.service'
export {TrapsService as Traps} from './traps.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {ItemsServices as Items} from './itemsService'
export {AllServices as All} from './allService'